import * as React from "react";
import { observer } from "mobx-react";
import { IButtonProps } from "./IButtonProps";

@observer
export class Button extends React.Component<IButtonProps, {}> {

	render() {
		if (!this.props.hide) {
			let className = !this.props.pressed ? "button" : "button is--button-highlight";

			let label: any = this.props.label ? <span> {this.props.label}</span> : null;

			return <button id={this.props.id} className={className} disabled={this.props.disabled} onClick={this.props.onClick} data-test-id={this.props.testId} data-test-name={this.props.testName} title={this.props.title} style={this.props.style}>
				{this.props.children}
				{label}
			</button>;
		}
		else {
			return null;
		}
	}
}
